import AdministrativeGenderCodes from 'shared_src/dictionaries/demographics/AdministrativeGenderCodes'
import Education from 'shared_src/dictionaries/demographics/Education'
import EthnicityCodes from 'shared_src/dictionaries/demographics/EthnicityCodes'
import LanguageCodes from 'shared_src/dictionaries/demographics/LanguageCodes'
import MaritalStatusCodes from 'shared_src/dictionaries/demographics/MaritalStatusCodes'
import RaceCodes from 'shared_src/dictionaries/demographics/RaceCodes'
import ReligiousPreferenceCodes from 'shared_src/dictionaries/demographics/ReligiousPreferenceCodes'
import ResidenceTypeCodes from 'shared_src/dictionaries/demographics/ResidenceTypeCodes'
import DiagnoticCategorgies from 'shared_src/dictionaries/documents/DiagnosticCategories'
import GeneralDocuments from 'shared_src/dictionaries/documents/GeneralDocuments'
import Admissions from 'shared_src/dictionaries/encounters/AdmissionCodes'
import EncounterDetails from 'shared_src/dictionaries/encounters/EncounterDetails'
import MedicationAmounts from 'shared_src/dictionaries/medications/MedicationAmounts'
import MedicationFrequencies from 'shared_src/dictionaries/medications/MedicationFrequencies'
import MedicationRoutes from 'shared_src/dictionaries/medications/MedicationRoutes'
import MedicationUnits from 'shared_src/dictionaries/medications/MedicationUnits'
import NpiPrefix from 'shared_src/dictionaries/providers/NpiPrefix'
import NpiSuffix from 'shared_src/dictionaries/providers/NpiSuffix'
import Nucc from 'shared_src/dictionaries/providers/Nucc'
import RelationshipCodes from 'shared_src/dictionaries/relatedPerson/Relationships'
import SystemRoles from 'shared_src/dictionaries/roles/SystemRoles'

import ActionStatuses from './ActionStatuses.js'
import ContactPointCodes from './ContactPointCodes.js'
import DiagnosticCategories from './DiagnosticCategories.js'
import EsasCategoryCodes from './EsasCategoryCodes.js'
import IssuePriorities from './IssuePriorityCodes.js'
import MilitaryCodes from './MilitaryCodes.js'
import NameSuffixCodes from './NameSuffixCodes.js'
import OrganizationTypes from './OrganizationType.js'
import Qualifications from './Qualifications.js'
import Roles from './Roles.js'
import USStateCodes from './USStateCodes.js'

export {
  MedicationAmounts,
  RelationshipCodes,
  MedicationUnits,
  MedicationRoutes,
  MedicationFrequencies,
  ActionStatuses,
  AdministrativeGenderCodes,
  Admissions,
  EncounterDetails,
  ContactPointCodes,
  DiagnosticCategories,
  Education,
  EsasCategoryCodes,
  EthnicityCodes,
  SystemRoles,
  IssuePriorities,
  LanguageCodes,
  MaritalStatusCodes,
  MilitaryCodes,
  OrganizationTypes,
  NameSuffixCodes,
  Qualifications,
  RaceCodes,
  ReligiousPreferenceCodes,
  ResidenceTypeCodes,
  Roles,
  USStateCodes,
  NpiPrefix,
  NpiSuffix,
  Nucc,
  GeneralDocuments,
  DiagnoticCategorgies
}

export const filterLevel = (codes = [], level) =>
  codes.filter(item => item.level === undefined || item.level <= level)

export default {
  MedicationAmounts,
  MedicationUnits,
  MedicationRoutes,
  MedicationFrequencies,
  ActionStatuses,
  AdministrativeGenderCodes,
  SystemRoles,
  Admissions,
  EncounterDetails,
  ContactPointCodes,
  DiagnosticCategories,
  Education,
  EsasCategoryCodes,
  EthnicityCodes,
  IssuePriorities,
  LanguageCodes,
  MaritalStatusCodes,
  MilitaryCodes,
  OrganizationTypes,
  NameSuffixCodes,
  Qualifications,
  RaceCodes,
  RelationshipCodes,
  ReligiousPreferenceCodes,
  ResidenceTypeCodes,
  Roles,
  USStateCodes,
  filterLevel,
  NpiPrefix,
  NpiSuffix,
  Nucc,
  GeneralDocuments,
  DiagnoticCategorgies
}
